import gql from 'graphql-tag'

export default gql`
  mutation validateUsersSubscriptions($users: [StripeUserInput]!) {
    validateUsersSubscriptions(users: $users) {
      success
      message
      users {
        email
        status
      }
    }
  }
`
